import { useEffect } from "react";

// Ventana modal accesible: se cierra con Escape, con el botón de cerrar o al hacer clic
// afuera. Si es más alta que la pantalla se desplaza la ventana, no la página de atrás.
function Modal({ titulo, onCerrar, children, ancho = "max-w-md" }) {
  useEffect(() => {
    const alPresionar = (e) => e.key === "Escape" && onCerrar();
    window.addEventListener("keydown", alPresionar);
    return () => window.removeEventListener("keydown", alPresionar);
  }, [onCerrar]);

  useEffect(() => {
    const anterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = anterior; };
  }, []);

  const cerrarAfuera = (e) => e.target === e.currentTarget && onCerrar();

  return (
    <div
      className="ventana-fondo fixed inset-0 z-50 overflow-y-auto overscroll-contain bg-black/80 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={titulo}
      onMouseDown={cerrarAfuera}
    >
      <div className="flex min-h-full items-center justify-center p-4 sm:p-8" onMouseDown={cerrarAfuera}>
        <div className={`ventana-panel w-full ${ancho} rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8`}>
          <div className="mb-6 flex items-start justify-between gap-4">
            <h3 className="titulo-ventana">{titulo}</h3>
            <button onClick={onCerrar} aria-label="Cerrar" className="text-2xl leading-none text-gray-500 transition hover:text-white">
              ×
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
